const INIT_STATE = {
  show: false,
  infos: [],
  errors: [],
  data: {},
};

export function CreateXeroTaxModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'SHOW_XERO_TAX_MODAL': {
      return {
        ...state,
        show: true,
      };
    }
    case 'HIDE_XERO_TAX_MODAL': {
      return {
        ...state,
        show: false,
      };
    }
    case 'SET_INFO_XERO_TAX_MODAL': {
      return {
        ...state,
        infos: action.payload,
      };
    }
    case 'CLEAR_INFO_XERO_TAX_MODAL': {
      return {
        ...state,
        infos: [],
      };
    }
    case 'SET_DATA_XERO_TAX_MODAL': {
      return {
        ...state,
        data: action.payload,
      };
    }
    case 'SET_ERROR_XERO_TAX_MODAL': {
      return {
        ...state,
        errors: action.payload,
      };
    }
    case 'CLEAR_ERROR_XERO_TAX_MODAL': {
      return {
        ...state,
        errors: [],
      };
    }
    case 'RESET_XERO_TAX_MODAL': {
      return {
        ...INIT_STATE,
      };
    }
    default:
      return state;
  }
}
